<div class="page">
  <div class="title">
    <button class="buttonBack" *ngIf="step !== 1" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="titleValue">{{ "issue.title" | transloco }}</div>
    <div class="line"></div>
  </div>

  <div *ngIf="step === 2" style="margin-top: 20px">
    <div class="opcionesList">
      <div *ngFor="let sintoma of pasosCategory">
        <div class="optionCard">
          <div style="font-weight: 600">
            {{ "issue.option" | transloco }} {{ sintoma.opcion }}
          </div>
          <div class="pasosList" *ngFor="let paso of sintoma.pasos">
            <div class="pasoLine">
              ·
              {{
                activeLang === "en"
                  ? paso.English_EN
                  : activeLang === "fr"
                  ? paso.Fran_ais_FR
                  : paso.value
              }}
            </div>
            <div class="imagenesPaso" *ngFor="let imagen of paso.imagenes">
              <img
                class="imagenPaso"
                *ngIf="imagen.base64"
                [src]="imagen.base64"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 40px;
          "
        >
          <button
            class="buttonStyle"
            style="width: 340px"
            (click)="openMunicionRecomendada()"
          >
            {{ "issue.recommendedAmmo" | transloco }}
          </button>
        </div>
        <div
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 40px;
          "
        >
          <button
            class="buttonStyle"
            style="width: 340px"
            (click)="siguiente(3)"
          >
            {{ "issue.notSolvedProblem" | transloco }}
          </button>
        </div>
        <div
          *ngIf="pasosCategory.length > 0"
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 40px;
          "
        >
          <button
            class="buttonStyle"
            style="width: 300px; background-color: #f6c527"
            (click)="crearTicket('old_done')"
          >
            {{ "issue.solvedProblem" | transloco }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="layoutRegister" *ngIf="step === 1">
    <div class="register">
      <div class="titleForm">
        {{ "issue.enterData" | transloco }}
      </div>
      <form [formGroup]="formDatos" class="registerForm">
        <div class="inputRegisterGroup">
          <mat-label class="labelRegister">{{
            "general.name" | transloco
          }}</mat-label>
          <input
            class="inputRegister"
            matInput
            name="nombre"
            type="text"
            formControlName="nombre"
            [placeholder]="'general.namePlaceholder' | transloco"
            maxlength="200"
            [style]="
              camposBlocked.includes('nombre') ? 'border-color: red' : ''
            "
          />
        </div>
        <div class="inputRegisterGroup" style="margin-top: 22px">
          <mat-label class="labelRegister">{{
            "general.surname" | transloco
          }}</mat-label>
          <input
            class="inputRegister"
            matInput
            name="apellidos"
            type="text"
            formControlName="apellidos"
            [placeholder]="'general.surnamePlaceholder' | transloco"
            maxlength="200"
            [style]="
              camposBlocked.includes('apellidos') ? 'border-color: red' : ''
            "
          />
        </div>
        <div class="inputRegisterGroup" style="margin-top: 22px">
          <mat-label class="labelRegister">{{
            "general.email" | transloco
          }}</mat-label>
          <input
            class="inputRegister"
            matInput
            name="email"
            type="text"
            formControlName="email"
            [placeholder]="'general.emailPlaceholder' | transloco"
            maxlength="200"
            [style]="camposBlocked.includes('email') ? 'border-color: red' : ''"
          />
        </div>
        <div class="inputRegisterGroup" style="margin-top: 22px">
          <mat-label class="labelRegister">{{ "general.phone" }}</mat-label>
          <input
            class="inputRegister"
            matInput
            name="phone"
            type="text"
            formControlName="phone"
            pattern="\d*"
            [placeholder]="'genera.phonePlaceholder' | transloco"
            maxlength="200"
            [style]="camposBlocked.includes('phone') ? 'border-color: red' : ''"
          />
        </div>
        <div class="inputRegisterGroup" style="margin-top: 22px">
          <mat-label class="labelRegister">{{
            "general.postalCode" | transloco
          }}</mat-label>
          <input
            class="inputRegister"
            matInput
            name="cp"
            type="text"
            formControlName="cp"
            pattern="\d*"
            [placeholder]="'general.postalCodePlaceholder' | transloco"
            maxlength="200"
            [style]="camposBlocked.includes('cp') ? 'border-color: red' : ''"
          />
        </div>

        <div class="inputRegisterGroup" style="margin-top: 22px">
          <mat-label class="labelRegister">{{
            "issue.country" | transloco
          }}</mat-label>
          <mat-select
            class="selectRegister"
            name="pais"
            type="text"
            formControlName="pais"
            [placeholder]="'issue.countryPlaceholder' | transloco"
            maxlength="200"
            [style]="camposBlocked.includes('pais') ? 'border-color: red' : ''"
          >
            <mat-option *ngFor="let pais of paises" [value]="pais.id">
              {{
                activeLang === "en"
                  ? pais.English_EN
                  : activeLang === "fr"
                  ? pais.Fran_ais_FR
                  : pais.pais
              }}
            </mat-option>
          </mat-select>
        </div>

        <div class="inputRegisterGroup" style="margin-top: 22px">
          <mat-label class="labelRegister">{{
            "issue.serialNumber" | transloco
          }}</mat-label>
          <div class="mascara">
            <input
              class="inputProductoMascaraCorto"
              matInput
              name="numSerie1"
              type="text"
              pattern="\d*"
              #numSerie1Input
              formControlName="numserie1"
              maxlength="2"
              [style]="
                camposBlocked.includes('numserie1') ? 'border-color: red' : ''
              "
            />
            .
            <input
              class="inputProductoMascaraCorto"
              matInput
              name="numSerie2"
              type="text"
              pattern="\d*"
              #numSerie2Input
              formControlName="numserie2"
              maxlength="2"
              [style]="
                camposBlocked.includes('numserie2') ? 'border-color: red' : ''
              "
            />
            .
            <input
              class="inputProductoMascaraLargo"
              matInput
              name="numSerie3"
              type="text"
              pattern="\d*"
              #numSerie3Input
              formControlName="numserie3"
              maxlength="6"
              [style]="
                camposBlocked.includes('numserie3') ? 'border-color: red' : ''
              "
            />
            .
            <input
              class="inputProductoMascaraCorto"
              matInput
              name="numSerie4"
              type="text"
              pattern="\d*"
              #numSerie4Input
              formControlName="numserie4"
              maxlength="2"
              [style]="
                camposBlocked.includes('numserie4') ? 'border-color: red' : ''
              "
            />
          </div>
        </div>

        <div class="inputRegisterGroup" style="margin-top: 22px">
          <mat-label class="labelRegister">{{
            "issue.problem" | transloco
          }}</mat-label>
          <mat-select
            class="selectRegister"
            name="problema"
            type="text"
            formControlName="problema"
            [placeholder]="'issue.problemPlaceholder' | transloco"
            maxlength="200"
            [style]="
              camposBlocked.includes('problema') ? 'border-color: red' : ''
            "
          >
            <mat-option *ngFor="let sc of symptonCodes" [value]="sc.ID">
              {{
                activeLang === "en"
                  ? sc.English_EN
                  : activeLang === "fr"
                  ? sc.Fran_ais_FR
                  : sc.descripcion
              }}
            </mat-option>
            <mat-option [value]="0">{{ "issue.otherProbemOption" }}</mat-option>
          </mat-select>
        </div>

        <div
          *ngIf="this.formDatos.get('problema')?.value === 0"
          class="inputRegisterGroup"
          style="margin-top: 22px"
        >
          <mat-label class="labelRegister">{{
            "issue.section" | transloco
          }}</mat-label>
          <mat-select
            class="selectRegister"
            name="seccion"
            type="text"
            formControlName="seccion"
            [placeholder]="'issue.sectionPlaceholder' | transloco"
            maxlength="200"
          >
            <mat-option *ngFor="let sc of sectionCodes" [value]="sc.ID">
              {{
                activeLang === "en"
                  ? sc.English_EN
                  : activeLang === "fr"
                  ? sc.Fran_ais_FR
                  : sc.descripcion
              }}
            </mat-option>
          </mat-select>
        </div>

        <div class="inputCheckboxGroup" style="margin-top: 22px">
          <input
            class="inputCheckbox"
            name="politica"
            type="checkbox"
            formControlName="politica"
            maxlength="200"
            [style]="
              camposBlocked.includes('politica')
                ? 'border-color: red !important'
                : ''
            "
          />
          <mat-label
            class="labelPolitica"
            [innerHTML]="
              'general.termsAndPolicyCheck'
                | transloco
                  : {
                      termsLink: '/terminos-condiciones-app',
                      policyLink: '/politica-privacidad'
                    }
            "
          ></mat-label>
        </div>
      </form>

      <div
        style="
          display: flex;
          margin-top: 20px;
          align-items: center;
          justify-content: center;
          width: 100%;
        "
      >
        <button
          class="buttonCrear"
          *ngIf="this.formDatos.get('problema')?.value !== 0"
          (click)="siguiente(2)"
        >
          {{ "general.next" | transloco }}
        </button>
        <button
          class="buttonCrear"
          *ngIf="this.formDatos.get('problema')?.value === 0"
          (click)="siguiente(3)"
        >
          {{ "general.next" | transloco }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="step === 3">
    <form [formGroup]="formDatos" style="width: 100%">
      <div>
        <div class="labelMotivo" style="margin-top: 20px">
          {{ "issue.observations" | transloco }}
        </div>
        <div class="divTextareaMotivo">
          <textarea
            class="textareaMotivo"
            name="motivo"
            formControlName="motivo"
          ></textarea>
        </div>
      </div>
      <div class="adjuntosForm">
        <div class="labelMotivo" style="margin-top: 20px; margin-bottom: 20px">
          {{ "issue.attachments" | transloco }}
        </div>
        <div class="adjuntosBox">
          <div class="adjuntosGroup" *ngIf="adjuntos.length > 0">
            <div class="adjuntoCard" *ngFor="let adjunto of adjuntos">
              <div style="display: flex; justify-content: space-between">
                <div class="labelMotivo" style="margin-bottom: 10px">
                  {{ adjunto.name }}
                </div>
                <div (click)="deleteItemListMultimedia(adjunto)">
                  <mat-icon>delete</mat-icon>
                </div>
              </div>
              <div
                style="border-radius: 8px"
                *ngIf="adjunto.type === 'photo'"
                style="
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  height: 100%;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  [src]="adjunto.base64"
                  style="border-radius: 8px"
                  width="100%"
                  height="100%"
                />
              </div>
              <video
                style="border-radius: 8px"
                #previewVideo
                width="100%"
                height="100%"
                [src]="adjunto.base64"
                *ngIf="adjunto.type === 'video'"
                controls
              ></video>
            </div>
          </div>
          <div class="buttonAddAdjunto" (click)="openPhotoCaptureDialog()">
            +
          </div>
        </div>
      </div>
    </form>
    <div
      style="
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
      "
    >
      <button
        class="buttonStyle"
        style="width: 340px"
        (click)="crearTicket('new')"
      >
        {{ "issue.createIssue" | transloco }}
      </button>
    </div>
  </div>
</div>
